import * as React from 'react';
import * as anime from 'animejs';
import { withRouter, RouteComponentProps } from 'react-router';
import { Navigation } from '.';
import { Footer } from '.';

class Layout extends React.Component<RouteComponentProps<any>> {
  componentDidMount() {
    this.animateOverlay();
  }

  componentWillUpdate(nextProps: any) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.animateOverlay();
    }
  }

  animateOverlay = () => {
    const overlayAnimation = anime.timeline();

    overlayAnimation
      .add({
        targets: '.container__content',
        opacity: [1, 0],
        duration: 1,
        easing: 'easeInQuad'
      })
      .add({
        targets: '.container__overlay',
        translateX: ['-100%', '0'],
        duration: 300,
        easing: 'easeInQuad'
      })
      .add({
        targets: '.container__overlay',
        translateX: ['0', '0'],
        duration: 300,
        easing: 'easeOutQuad'
      })
      .add({
        targets: '.container__overlay',
        translateX: ['0', '100%'],
        duration: 300,
        easing: 'easeOutQuad'
      })
      .add({
        targets: '.container__content',
        opacity: [0, 1],
        duration: 100,
        easing: 'easeInQuad',
        offset: '-=600'
      });
  };

  render() {
    const { children } = this.props;

    return (
      <div className="container">
        <div className="container__overlay" />
        <div className="container__content">
          <header className="header">
            <div className="header__logo-container">
              <a href="/">
                <img
                  src={require('../assets/images/logos/auric-oak-logo.svg')}
                  className="logo"
                />
              </a>
            </div>
            <Navigation />
          </header>
          <main className="container__children">{children}</main>
          <Footer />
        </div>
        <div className="container__lightoverlay" />
      </div>
    );
  }
}

export default withRouter(Layout);



// WEBPACK FOOTER //
// ./src/main/components/Layout.tsx